// p5 runs in global mode, as it did when the page loaded it from a CDN: once the
// page has loaded it finds setup() and draw() on window (sketch.ts puts them
// there) and makes its functions and constants globals. p5.sound looks for a
// global p5 when it runs, so this module sets it before sketch.ts imports that.
import p5 from 'p5'

Object.assign(window, { p5 })
